@if (profile) {
  <div id="settings" class="settings-container mat-dialog-custom confirmation-dialog">
    <div class="title-container display-flex-container">
      <h1 class="title" i18n>System of measurement</h1>
      <a
        id="closeSettings"
        class="close"
        href="javascript:void(0);"
        aria-label="close"
        rdcAnalytics="Close System Of Measurement Settings"
        (click)="onCancel()"
        i18n-aria-label
      >
        <svg-icon src="/assets/icons/close.svg" alt="close" i18n-alt />
      </a>
    </div>
    <div class="settings-form-container">
      <form id="settings-form" name="settingsForm" novalidate [formGroup]="settingsForm" (submit)="onSave()">
        <mat-form-field class="helper-full-width">
          <mat-label [ngClass]="{ hasValue: profile.systemOfMeasurement }" i18n>Measurement</mat-label>
          <mat-select id="unitOfMeasure" name="systemOfMeasurement" value="" formControlName="systemOfMeasurement">
            <mat-option id="usStandard" value="Standard" i18n>US Standard</mat-option>
            <mat-option id="metric" value="Metric" i18n>Metric</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="buttons-container">
          <div class="left">
            <button
              id="saveBtn"
              class="button primary-button"
              type="submit"
              rdcAnalytics="Update System Of Measurement Settings"
              i18n
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
